import React from "react";
import moment from "moment";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, TileTitle, Tile, TileBody, TileItem } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUser, faColumns, faFileImport } from "@fortawesome/free-solid-svg-icons";

import createBlueprintIcon from "images/tileIcons/createBlueprint.svg";
import noBlueprintIcon from "images/tileIcons/noBlueprint.svg";

import blueprintWhiteIcon from "images/tileIcons/blueprint_white.svg";

import AibleBot from "images/wiz3.png";
import AibleQuickBot from "images/wiz2.png";
import HalIcon from "images/wiz1.png";
import blueprintImport from "images/export.svg";

import BlueprintExport from "components/ChatGPT/BlueprintExport";
import { isEnabled } from "utils/featureFlags";

import getStyles from "components/Home/Utils/getStyles";

import CreateTile from "components/Tiles/CreateTile";
import { LineInput } from "components/Inputs/LineInput";
import { getIsEDG } from "containers/Gallery/GalleryReducer";

import Optimized from "images/optimized.svg";
import Academic from "images/academic.svg";

import { AIBLE_MODES } from "containers/Wizard/reducer";

import styles from "./style.module.css";
import { toast } from "react-toastify";

const bpStyles = getStyles("blueprint");

export default class BlueprintTile extends React.Component {
  state = {
    isHover: false
  };

  handleOnClick(event) {
    const { onHover, onClick } = this.props;
    onHover && onHover(undefined);
    return onClick(event);
  }

  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  renderAible() {
    const { onClick, className } = this.props;

    return (
      <div className={styles.aibleTile + " " + (className ? className : "")} onClick={() => onClick(AIBLE_MODES.AIBLE)}>
        <div className={styles.aibleIcon}>
          <img src={Optimized} className={styles.aibleI} />
        </div>
        <div className={styles.mid}>{"Optimized"}</div>
        <div className={styles.bottom}>
          <div>{"Balance costs & benefits"}</div>
          <div>{"Respect business contraints"}</div>
          <div>{"Confirm better than current state"}</div>
        </div>
      </div>
    );
  }

  renderAcademic() {
    const { onClick, className } = this.props;

    return (
      <div
        className={styles.aibleTile + " " + (className ? className : "")}
        onClick={() => onClick(AIBLE_MODES.ACADEMIC)}
      >
        <div className={styles.aibleIcon}>
          <img src={Academic} className={styles.aibleI} style={{ height: "70px", width: "70px" }} />
        </div>
        <div className={styles.mid}>{"Quick Start"}</div>
        <div className={styles.bottom}>
          <div>{"Assumes costs = benefits"}</div>
          <div>{"No business contraints"}</div>
          <div>{"Ignores current state"}</div>
        </div>
      </div>
    );
  }

  renderQuickStart() {
    const { onClick, className } = this.props;

    return (
      <div
        className={styles.aibleTile + " " + (className ? className : "")}
        onClick={() => onClick(AIBLE_MODES.ACADEMIC)}
        style={{ margin: "10px" }}
      >
        <div className={styles.aibleIcon}>
          <img src={Academic} className={styles.aibleI} style={{ height: "70px", width: "70px" }} />
        </div>
        <div className={styles.mid}>{"Quick Start"}</div>
      </div>
    );
  }

  render() {
    const {
      blueprint,
      dataset,
      datasetType,
      customFields,
      getOriginalAuthor,
      updateIsEditing,
      isCreate,
      isCreateDisabled,
      isImport,
      isAible,
      isAcademic,
      isQuickStart,
      isCreateNoBlueprint,
      isHighlight,
      handleDelete,
      updateMoveBlueprintId,
      linkedDatasets,
      onClick,
      onEditClick,
      isEditBlueprint,
      noClick,
      onHover,
      noHover,
      history,
      hideDelete,
      noDescriptionLabel,
      onClickLabel,
      image,
      noPermissionsText,
      optimized,
      segmentSetups
    } = this.props;

    const { isHover } = this.state;

    if (isCreate || isCreateNoBlueprint) {
      return (
        <CreateBlueprintTile
          isCreateDisabled={isCreateDisabled}
          noBlueprint={isCreateNoBlueprint}
          onClick={onClick}
          title={onClickLabel}
          image={image}
          noPermissionsText={noPermissionsText}
        />
      );
    }

    if (isImport) {
      return <ImportBlueprintTile {...this.props} />;
    }

    if (isAible) {
      return this.renderAible();
    }

    if (isAcademic) {
      return this.renderAcademic();
    }

    if (isQuickStart) {
      return this.renderQuickStart();
    }

    if (!blueprint) {
      return <React.Fragment></React.Fragment>;
    }

    const datasetOutcome = dataset && dataset.outcome;

    const columns = dataset && dataset.fields ? Object.keys(dataset.fields) : false;
    const columnCount = columns ? columns.length : 0;

    const isTourBlueprint = blueprint && blueprint.id && (blueprint.id === 12100 || blueprint.id === 979);

    let author = blueprint.created_by ? blueprint.created_by.fullname : undefined;
    if (blueprint.wizard && blueprint.wizard.marketplace && blueprint.wizard.marketplace.created_by) {
      author =
        (typeof blueprint.wizard.marketplace.created_by === "object"
          ? blueprint.wizard.marketplace.created_by.fullname
          : blueprint.wizard.marketplace.created_by) || "";
    }

    const isChatGPT = blueprint.wizard?.chatGPT !== undefined;

    switch (blueprint.id) {
      case "AIBLE":
        return <CreateBlueprintTile image={AibleBot} title={"Aible Create"} onClick={onClick} />;
      case "QUICK":
        return <CreateBlueprintTile image={AibleQuickBot} title={"Quick Run"} onClick={onClick} />;
      case "ACADEMIC":
        return <CreateBlueprintTile image={HalIcon} title={"Academic"} onClick={onClick} />;
      default:
    }
    if (getIsEDG()) {
      return (
        <Tile
          onClick={onClick ? (e) => this.handleOnClick(e) : onClick}
          onMouseEnter={() => {
            onHover && onHover(blueprint.id);
            return this.setState({ isHover: true });
          }}
          onMouseLeave={() => {
            onHover && onHover(undefined);
            return this.setState({ isHover: false });
          }}
          id={isTourBlueprint ? "aibleTourBlueprint" : undefined}
          buttonText={"View Blueprint"}
          handleDelete={handleDelete ? (e) => this.handleDelete(e) : handleDelete}
          hideDelete={hideDelete}
          active={isHighlight}
          noHover={noHover}
        >
          <TileTitle title={blueprint.name + " (" + blueprint.id + ")"} icon={"blueprint"} color={"blueprint"}>
            {blueprint.name}
          </TileTitle>
          {isHover || true ? (
            <TileBody>
              <TileItem
                icon={linkedDatasets.length ? "data" : "data"}
                // overlay={
                //   <React.Fragment>
                //     {customFields.map((field, i) => (
                //       <div className={styles.oField} key={field && field.id}>
                //         {field && field.id}
                //       </div>
                //     ))}
                //   </React.Fragment>
                // }
              >
                {linkedDatasets.length + " Linked Dataset" + (linkedDatasets.length !== 1 ? "s" : "")}
              </TileItem>
              <TileItem icon={"user"}>{author}</TileItem>
              <TileItem
                icon={"calendar"}
                overlay={moment.utc(blueprint.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(blueprint.created_date).local().fromNow()}
              </TileItem>
            </TileBody>
          ) : (
            <TileBody></TileBody>
          )}
        </Tile>
      );
    }

    return (
      <Tile
        onClick={onClick ? (e) => this.handleOnClick(e) : onClick}
        onMouseEnter={() => {
          onHover && onHover(blueprint.id);
          return this.setState({ isHover: true });
        }}
        onMouseLeave={() => {
          onHover && onHover(undefined);
          return this.setState({ isHover: false });
        }}
        id={isTourBlueprint ? "aibleTourBlueprint" : undefined}
        buttonText={onClickLabel ?? "Use Blueprint"}
        secondButton={onEditClick ? "Edit Blueprint" : undefined}
        thirdButton={"Copy Blueprint"}
        onClickSecond={onEditClick}
        onClickThird={() => {
          toast("Blueprint copied to clipboard.", {
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3500
          });

          const retBlueprint = {
            ...blueprint,
            wizard: {
              ...(blueprint?.wizard ?? {}),
              setup: optimized?.setup ?? blueprint?.wizard?.setup,
              segmentSetups: segmentSetups,
              dataset: {
                ...(blueprint?.wizard?.dataset ?? {}),
                pivot_tables: {}
              }
            }
          };

          navigator.clipboard.writeText(JSON.stringify(retBlueprint));
        }}
        handleDelete={handleDelete ? (e) => this.handleDelete(e) : handleDelete}
        // TODO: Move Folder action
        //handleMoveFolder={() => updateMoveBlueprintId(blueprint?.id)}
        hideDelete={hideDelete}
        active={isHighlight}
        noHover={noHover}
        isButtonPrimary={true}
      >
        <TileTitle title={blueprint.name + " (" + blueprint.id + ")"} icon={"blueprint"} color={"blueprint"}>
          {blueprint.name}
        </TileTitle>
        <TileBody>
          {isHover || !(blueprint.wizard && blueprint.wizard.description) ? (
            <React.Fragment>
              {datasetOutcome ? <TileItem icon={"target"}>{datasetOutcome}</TileItem> : ""}
              {datasetType ? (
                <TileItem icon={"arrowSideways"} style={{ textTransform: "capitalize" }}>
                  {datasetType}
                </TileItem>
              ) : (
                ""
              )}
              {customFields && customFields.length ? (
                <TileItem
                  icon={"checkBox"}
                  overlay={
                    <React.Fragment>
                      {customFields.map((field, i) => (
                        <div className={styles.oField} key={field && field.id}>
                          {field && field.id}
                        </div>
                      ))}
                    </React.Fragment>
                  }
                >
                  {customFields.length + " Business Assumption" + (customFields.length !== 1 ? "s" : "")}
                </TileItem>
              ) : (
                ""
              )}
              {isChatGPT && isEnabled("chat-aible-advanced-controls") && (
                <BlueprintExport blueprint={blueprint}>
                  <TileItem icon={"link"} onClick={() => {}}>
                    {"Export Agent Template"}
                  </TileItem>
                </BlueprintExport>
              )}
              <TileItem icon={"user"}>{author}</TileItem>
              <TileItem
                icon={"calendar"}
                overlay={moment.utc(blueprint.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(blueprint.created_date).local().fromNow()}
              </TileItem>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {!noDescriptionLabel && <div className={styles.blueprintDescriptionLabel}>Blueprint Goals</div>}
              <div className={styles.blueprintDescription}>{blueprint.wizard.description}</div>
            </React.Fragment>
          )}
        </TileBody>
      </Tile>
    );
  }
}

export class ImportBlueprintTile extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isImport: false };
  }

  handleCreateBlueprint() {
    const { createBlueprint } = this.props;
    const { blueprint } = this.state;

    createBlueprint(JSON.parse(blueprint));
    this.setState({ blueprint: undefined, isImport: false });
  }

  render() {
    const { onClick, noBlueprint, title, img } = this.props;
    const { isImport } = this.state;

    const text = "Import Blueprint";

    return (
      <Tile
        onClick={() => this.setState({ isImport: true })}
        buttonText={text}
        showButton={!isImport}
        hideButton={isImport}
        isTileClick={!isImport}
      >
        <TileBody>
          {isImport === false ? (
            <div className={styles.createTileIconWrapper}>
              <div className={styles.createTileIcon}>
                <img src={blueprintImport} alt={text} />
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div className={styles.createTileHeader + " " + bpStyles.text}>{"Importing"}</div>
              <div className={styles.createTileIcon} style={{ paddingLeft: "10px" }}>
                <LineInput isMediumBox onChange={(val) => this.setState({ blueprint: val })} />
              </div>
              <div className={styles.importButtons}>
                <Button
                  type="secondary"
                  style={{ marginRight: "20px" }}
                  onClick={() => this.setState({ isImport: false })}
                >
                  {"Cancel"}
                </Button>
                <Button type="secondary" onClick={() => this.handleCreateBlueprint()}>
                  {"Create"}
                </Button>
              </div>
            </React.Fragment>
          )}
        </TileBody>
      </Tile>
    );

    return (
      <div className={styles.tileWrapper}>
        {isImport === false ? (
          <div className={styles.tile} onClick={() => this.setState({ isImport: true })}>
            <div className={styles.createTileImageWrapper}>
              <div className={styles.importIcon}>
                <img src={blueprintImport} />
              </div>
            </div>
            <div className={styles.createTileBody}>
              <div className={styles.createTileHeader + " " + bpStyles.text}>{text}</div>
            </div>
          </div>
        ) : (
          <div className={styles.tile}>
            <div className={styles.createTileIcon}>
              <LineInput isMediumBox onChange={(val) => this.setState({ blueprint: val })} />
            </div>
            <div className={styles.buttons}>
              <Button
                type="secondary"
                style={{ marginRight: "20px" }}
                onClick={() => this.setState({ isImport: false })}
              >
                {"Cancel"}
              </Button>
              <Button type="secondary" onClick={() => this.handleCreateBlueprint()}>
                {"Create"}
              </Button>
            </div>
            <div className={styles.createTileBody}>
              <div className={styles.createTileHeader + " " + bpStyles.text}>{"Importing"}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export class CreateBlueprintTile extends React.PureComponent {
  render() {
    const { onClick, noBlueprint, title, image, noPermissionsText, isCreateDisabled } = this.props;
    const text = title ? title : noBlueprint ? "Continue Without Blueprint" : "Create New Blueprint";

    return (
      <CreateTile
        onClick={onClick}
        noPermissions={isCreateDisabled}
        noPermissionsText={noPermissionsText ?? "You don't have permission to create a blueprint in this folder."}
        buttonText={text}
        loadingText={text}
        icon={image ? image : noBlueprint ? noBlueprintIcon : createBlueprintIcon}
      />
    );
  }
}
